import { GraphQLClient } from 'graphql-request';
import { RequestInit } from 'graphql-request/dist/types.dom';
import { useMutation, useQuery, UseMutationOptions, UseQueryOptions } from '@tanstack/react-query';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };

function fetcher<TData, TVariables extends { [key: string]: any }>(client: GraphQLClient, query: string, variables?: TVariables, requestHeaders?: RequestInit['headers']) {
  return async (): Promise<TData> => client.request({
    document: query,
    variables,
    requestHeaders
  });
}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Any: { input: any; output: any; }
  AnyAggridInput: { input: any; output: any; }
  Date: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  Decimal: { input: any; output: any; }
  Json: { input: any; output: any; }
};

/** Type description */
export type ActivityLog = {
  __typename?: 'ActivityLog';
  activity_detail?: Maybe<ActivityLogDetailObject>;
  activity_type?: Maybe<ActivityType>;
  created_by?: Maybe<CreatorObject>;
  created_date?: Maybe<Scalars['DateTime']['output']>;
  document_type?: Maybe<ActivityLogDocumentType>;
  /** field description */
  id: Scalars['Int']['output'];
  reference_id?: Maybe<Scalars['Int']['output']>;
};

export type ActivityLogByRefereceIdInput = {
  document_type: ActivityLogDocumentType;
  reference_id: Scalars['Int']['input'];
};

export type ActivityLogCopyObject = {
  __typename?: 'ActivityLogCopyObject';
  id?: Maybe<Scalars['Int']['output']>;
  unique_id?: Maybe<Scalars['String']['output']>;
};

export type ActivityLogCopyObjectInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  unique_id?: InputMaybe<Scalars['String']['input']>;
};

export type ActivityLogCreateInput = {
  activity_detail: ActivityLogDetailObjectInput;
  activity_type: ActivityType;
  created_by: CreatorInputObject;
  document_type: ActivityLogDocumentType;
  reference_id: Scalars['Int']['input'];
};

export type ActivityLogDetailObject = {
  __typename?: 'ActivityLogDetailObject';
  added_related_employee?: Maybe<ActivityLogRelatedEmployeeObject>;
  attachment_list?: Maybe<Array<Scalars['String']['output']>>;
  copied_from?: Maybe<ActivityLogCopyObject>;
  copied_to?: Maybe<ActivityLogCopyObject>;
  curr_status?: Maybe<Scalars['String']['output']>;
  deleted_related_employee?: Maybe<ActivityLogRelatedEmployeeObject>;
  message?: Maybe<Array<Scalars['String']['output']>>;
  prev_status?: Maybe<Scalars['String']['output']>;
  updated_fields?: Maybe<Scalars['Json']['output']>;
};

export type ActivityLogDetailObjectInput = {
  added_related_employee?: InputMaybe<ActivityLogRelatedEmployeeObjectInput>;
  attachment_list?: InputMaybe<Array<Scalars['String']['input']>>;
  copied_from?: InputMaybe<ActivityLogCopyObjectInput>;
  copied_to?: InputMaybe<ActivityLogCopyObjectInput>;
  curr_status?: InputMaybe<Scalars['String']['input']>;
  deleted_related_employee?: InputMaybe<ActivityLogRelatedEmployeeObjectInput>;
  message?: InputMaybe<Array<Scalars['String']['input']>>;
  prev_status?: InputMaybe<Scalars['String']['input']>;
  secondary_operation?: InputMaybe<ActivityType>;
  updated_fields?: InputMaybe<Scalars['Json']['input']>;
};

export enum ActivityLogDocumentType {
  BillingNote = 'billing_note',
  CashSales = 'cash_sales',
  Contact = 'contact',
  CreditNote = 'credit_note',
  DeliveryOrder = 'delivery_order',
  DeliveryTrip = 'delivery_trip',
  DepositInvoice = 'deposit_invoice',
  GoodsAdjustment = 'goods_adjustment',
  GoodsIssue = 'goods_issue',
  GoodsReceive = 'goods_receive',
  GoodsReturn = 'goods_return',
  GoodsTransfer = 'goods_transfer',
  Item = 'item',
  Maintenance = 'maintenance',
  Promotion = 'promotion',
  PurchaseInvoice = 'purchase_invoice',
  PurchaseOrder = 'purchase_order',
  PurchaseRequest = 'purchase_request',
  PurchaseReturn = 'purchase_return',
  Quotation = 'quotation',
  Role = 'role',
  SalesInvoice = 'sales_invoice',
  SalesOrder = 'sales_order',
  SalesReturn = 'sales_return',
  Tire = 'tire',
  User = 'user',
  Vehicle = 'vehicle'
}

export type ActivityLogFindManyAggrid = {
  __typename?: 'ActivityLogFindManyAggrid';
  count: Scalars['Int']['output'];
  results: Array<ActivityLog>;
};

export type ActivityLogRelatedEmployeeObject = {
  __typename?: 'ActivityLogRelatedEmployeeObject';
  first_name?: Maybe<Scalars['String']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  user_unique_id?: Maybe<Scalars['String']['output']>;
};

export type ActivityLogRelatedEmployeeObjectInput = {
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  user_unique_id?: InputMaybe<Scalars['String']['input']>;
};

export type ActivityLogUniqueInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export enum ActivityType {
  Active = 'active',
  AddRelatedEmployee = 'add_related_employee',
  Approve = 'approve',
  Cancel = 'cancel',
  CancelPendingScan = 'cancel_pending_scan',
  ChangePassword = 'change_password',
  Comment = 'comment',
  Copy = 'copy',
  Create = 'create',
  CreateImporter = 'create_importer',
  Delete = 'delete',
  DeleteRelatedEmployee = 'delete_related_employee',
  Document = 'document',
  Edit = 'edit',
  EditImporter = 'edit_importer',
  EditPermission = 'edit_permission',
  Image = 'image',
  InActive = 'in_active',
  SaveDatePayment = 'save_date_payment',
  StatusChange = 'status_change'
}

export enum AdditionalDiscountType {
  Baht = 'baht',
  Percent = 'percent'
}

export type AddressInputObject = {
  address_contact_fax?: InputMaybe<Scalars['String']['input']>;
  address_contact_name?: InputMaybe<Scalars['String']['input']>;
  address_contact_phone?: InputMaybe<Scalars['String']['input']>;
  address_type?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  district?: InputMaybe<Scalars['String']['input']>;
  is_default?: InputMaybe<Scalars['Boolean']['input']>;
  is_same_as_default_address?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  postal_code?: InputMaybe<Scalars['String']['input']>;
  province?: InputMaybe<Scalars['String']['input']>;
  sub_district?: InputMaybe<Scalars['String']['input']>;
};

export type AddressObject = {
  __typename?: 'AddressObject';
  address_contact_fax?: Maybe<Scalars['String']['output']>;
  address_contact_name?: Maybe<Scalars['String']['output']>;
  address_contact_phone?: Maybe<Scalars['String']['output']>;
  address_type?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  district?: Maybe<Scalars['String']['output']>;
  is_default?: Maybe<Scalars['Boolean']['output']>;
  is_same_as_default_address?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  postal_code?: Maybe<Scalars['String']['output']>;
  province?: Maybe<Scalars['String']['output']>;
  sub_district?: Maybe<Scalars['String']['output']>;
};

export enum AggridArrayFilterType {
  Array = 'array'
}

export type AggridBooleanFilterModelInput = {
  filter?: InputMaybe<Scalars['String']['input']>;
  filterType?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<AggridBooleanFilterModelType>;
};

export enum AggridBooleanFilterModelType {
  Equals = 'equals',
  NotEqual = 'notEqual'
}

export type AggridDateFilterModelInput = {
  filter?: InputMaybe<Scalars['String']['input']>;
  filterTo?: InputMaybe<Scalars['String']['input']>;
  filterType?: InputMaybe<AggridDateFilterType>;
  type?: InputMaybe<AggridDateFilterModelType>;
};

export enum AggridDateFilterModelType {
  Blank = 'blank',
  Empty = 'empty',
  Equals = 'equals',
  GreaterThan = 'greaterThan',
  GreaterThanOrEqual = 'greaterThanOrEqual',
  InRange = 'inRange',
  LessThan = 'lessThan',
  LessThanOrEqual = 'lessThanOrEqual',
  NotBlank = 'notBlank',
  NotEqual = 'notEqual'
}

export enum AggridDateFilterType {
  Date = 'date'
}

export type AggridFloatFilterModelInput = {
  condition1?: InputMaybe<AggridFloatFilterModelInputCondition>;
  condition2?: InputMaybe<AggridFloatFilterModelInputCondition>;
  filter?: InputMaybe<Scalars['Float']['input']>;
  filterTo?: InputMaybe<Scalars['Float']['input']>;
  filterType?: InputMaybe<AggridNumberFilterType>;
  operator?: InputMaybe<AggridOperatorFilter>;
  type?: InputMaybe<AggridNumberFilterModelType>;
};

export type AggridFloatFilterModelInputCondition = {
  filter?: InputMaybe<Scalars['Float']['input']>;
  filterTo?: InputMaybe<Scalars['Float']['input']>;
  filterType?: InputMaybe<AggridNumberFilterType>;
  type?: InputMaybe<AggridNumberFilterModelType>;
};

export type AggridGenericArrayFilterModelInput = {
  filterType?: InputMaybe<AggridArrayFilterType>;
  type?: InputMaybe<AggridGenericArrayFilterModelType>;
  values?: InputMaybe<Scalars['Any']['input']>;
};

export enum AggridGenericArrayFilterModelType {
  Equals = 'equals',
  Has = 'has',
  HasEvery = 'hasEvery',
  HasSome = 'hasSome',
  IsEmpty = 'isEmpty'
}

export enum AggridISimpleFilterModelType {
  Blank = 'blank',
  Contains = 'contains',
  Empty = 'empty',
  EndsWith = 'endsWith',
  Equals = 'equals',
  GreaterThan = 'greaterThan',
  GreaterThanOrEqual = 'greaterThanOrEqual',
  InRange = 'inRange',
  LessThan = 'lessThan',
  LessThanOrEqual = 'lessThanOrEqual',
  NotBlank = 'notBlank',
  NotContains = 'notContains',
  NotEqual = 'notEqual',
  StartsWith = 'startsWith'
}

export type AggridIntFilterModelInput = {
  condition1?: InputMaybe<AggridIntFilterModelInputCondition>;
  condition2?: InputMaybe<AggridIntFilterModelInputCondition>;
  filter?: InputMaybe<Scalars['Int']['input']>;
  filterTo?: InputMaybe<Scalars['Int']['input']>;
  filterType?: InputMaybe<AggridNumberFilterType>;
  operator?: InputMaybe<AggridOperatorFilter>;
  type?: InputMaybe<AggridNumberFilterModelType>;
};

export type AggridIntFilterModelInputCondition = {
  filter?: InputMaybe<Scalars['Int']['input']>;
  filterTo?: InputMaybe<Scalars['Int']['input']>;
  filterType?: InputMaybe<AggridNumberFilterType>;
  type?: InputMaybe<AggridNumberFilterModelType>;
};

export enum AggridNumberFilterModelType {
  Blank = 'blank',
  Empty = 'empty',
  Equals = 'equals',
  GreaterThan = 'greaterThan',
  GreaterThanOrEqual = 'greaterThanOrEqual',
  InRange = 'inRange',
  LessThan = 'lessThan',
  LessThanOrEqual = 'lessThanOrEqual',
  NotBlank = 'notBlank',
  NotEqual = 'notEqual'
}

export enum AggridNumberFilterType {
  Number = 'number'
}

export enum AggridObjectArrayFilterModelType {
  Every = 'every',
  None = 'none',
  Some = 'some'
}

export enum AggridObjectArrayFilterType {
  ObjectArray = 'objectArray'
}

export enum AggridOperatorFilter {
  And = 'AND',
  Or = 'OR'
}

export type AggridSetSingleFilterModelInput = {
  condition1?: InputMaybe<AggridSetSingleFilterModelInputCondition>;
  condition2?: InputMaybe<AggridSetSingleFilterModelInputCondition>;
  filterType?: InputMaybe<Scalars['String']['input']>;
  operator?: InputMaybe<AggridOperatorFilter>;
  values?: InputMaybe<Array<InputMaybe<Scalars['Any']['input']>>>;
};

export type AggridSetSingleFilterModelInputCondition = {
  filterType?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<AggridSetSingleFilterModelType>;
  values?: InputMaybe<Array<InputMaybe<Scalars['Any']['input']>>>;
};

export enum AggridSetSingleFilterModelType {
  Blank = 'blank',
  Contains = 'contains',
  Equals = 'equals',
  NotBlank = 'notBlank',
  NotContains = 'notContains',
  NotEqual = 'notEqual'
}

export type AggridSortModelItem = {
  colId?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortOrder>;
};

export type AggridSortModelItemInput = {
  colId: Scalars['String']['input'];
  sort: SortOrder;
};

export type AggridStringFilterModelInput = {
  condition1?: InputMaybe<AggridStringFilterModelInputCondition>;
  condition2?: InputMaybe<AggridStringFilterModelInputCondition>;
  filter?: InputMaybe<Scalars['String']['input']>;
  filterTo?: InputMaybe<Scalars['String']['input']>;
  filterType?: InputMaybe<AggridTextFilterType>;
  mode?: InputMaybe<AggridStringModeOption>;
  operator?: InputMaybe<AggridOperatorFilter>;
  type?: InputMaybe<AggridStringFilterModelType>;
};

export type AggridStringFilterModelInputCondition = {
  filter?: InputMaybe<Scalars['String']['input']>;
  filterTo?: InputMaybe<Scalars['String']['input']>;
  filterType?: InputMaybe<AggridTextFilterType>;
  mode?: InputMaybe<AggridStringModeOption>;
  type?: InputMaybe<AggridStringFilterModelType>;
};

export enum AggridStringFilterModelType {
  Blank = 'blank',
  Contains = 'contains',
  Empty = 'empty',
  EndsWith = 'endsWith',
  Equals = 'equals',
  NotBlank = 'notBlank',
  NotContains = 'notContains',
  NotEqual = 'notEqual',
  StartsWith = 'startsWith'
}

export enum AggridStringModeOption {
  Default = 'default',
  Insensitive = 'insensitive'
}

export type AggridTemplateInput = {
  endRow?: InputMaybe<Scalars['Int']['input']>;
  filterModel?: InputMaybe<Scalars['Any']['input']>;
  sortModel?: InputMaybe<Array<AggridSortModelItemInput>>;
  startRow?: InputMaybe<Scalars['Int']['input']>;
};

export enum AggridTextFilterType {
  Text = 'text'
}

export type AttachmentInputObject = {
  attachment_name?: InputMaybe<Scalars['String']['input']>;
  uploaded_by?: InputMaybe<CreatorInputObject>;
  uploaded_date?: InputMaybe<Scalars['DateTime']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type AttachmentObject = {
  __typename?: 'AttachmentObject';
  attachment_name?: Maybe<Scalars['String']['output']>;
  uploaded_by?: Maybe<CreatorObject>;
  uploaded_date?: Maybe<Scalars['DateTime']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type BinLocation = {
  __typename?: 'BinLocation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  warehouse_level_3: WarehouseLevel3;
};

export type CompanyUniqueInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  unique_id?: InputMaybe<Scalars['String']['input']>;
};

export type ContactChannelInputObject = {
  contact_channel_info?: InputMaybe<Scalars['String']['input']>;
  contact_channel_type?: InputMaybe<Scalars['String']['input']>;
};

export type ContactChannelObject = {
  __typename?: 'ContactChannelObject';
  contact_channel_info?: Maybe<Scalars['String']['output']>;
  contact_channel_type?: Maybe<Scalars['String']['output']>;
};

export type CreatorInputObject = {
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  img_url?: InputMaybe<Array<Scalars['String']['input']>>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
  user_unique_id?: InputMaybe<Scalars['String']['input']>;
};

export type CreatorObject = {
  __typename?: 'CreatorObject';
  email?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  img_url?: Maybe<Array<Scalars['String']['output']>>;
  last_name?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
  user_unique_id?: Maybe<Scalars['String']['output']>;
};

export type CustomPurchaseOrder = {
  __typename?: 'CustomPurchaseOrder';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<PurchaseOrder>>>;
};

export type CustomPurchaseReturn = {
  __typename?: 'CustomPurchaseReturn';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<PurchaseReturn>>>;
};

export type ExportGenerateInput = {
  end_date?: InputMaybe<Scalars['DateTime']['input']>;
  export_type: PurchaseExportType;
  params?: InputMaybe<Scalars['Json']['input']>;
  start_date?: InputMaybe<Scalars['DateTime']['input']>;
  user_unique_id?: InputMaybe<Scalars['String']['input']>;
};

export type GeneralExportInput = {
  end_date?: InputMaybe<Scalars['DateTime']['input']>;
  start_date?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ImageUrlInputObjectInput = {
  img_url?: InputMaybe<Scalars['String']['input']>;
  is_main_img?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ImageUrlObject = {
  __typename?: 'ImageUrlObject';
  img_url?: Maybe<Scalars['String']['output']>;
  is_main_img?: Maybe<Scalars['Boolean']['output']>;
};

export type InventorySetting = {
  __typename?: 'InventorySetting';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  type: InventorySettingType;
};

export enum InventorySettingType {
  Cate_1 = 'cate_1',
  Cate_2 = 'cate_2',
  Cate_3 = 'cate_3',
  Unit = 'unit'
}

export type Mutation = {
  __typename?: 'Mutation';
  PurchaseOrderCreate?: Maybe<PurchaseOrder>;
  PurchaseOrderUpdate?: Maybe<PurchaseOrder>;
  PurchaseReturnCreate: PurchaseReturn;
  PurchaseReturnUpdate: PurchaseReturn;
};


export type MutationPurchaseOrderCreateArgs = {
  data?: InputMaybe<PurchaseOrderInput>;
};


export type MutationPurchaseOrderUpdateArgs = {
  data?: InputMaybe<PurchaseOrderUpdateInput>;
  uniqueInput?: InputMaybe<PurchaseUniqueInput>;
};


export type MutationPurchaseReturnCreateArgs = {
  data: PurchaseReturnCreateInput;
};


export type MutationPurchaseReturnUpdateArgs = {
  data?: InputMaybe<PurchaseReturnUpdateInput>;
  uniqueInput?: InputMaybe<PurchaseUniqueInput>;
};

export enum PriceVatType {
  ExcludedVat = 'excluded_vat',
  IncludedVat = 'included_vat'
}

export type PurchaseByDueDateExportViewsAggridOutput = {
  __typename?: 'PurchaseByDueDateExportViewsAggridOutput';
  count?: Maybe<Scalars['Int']['output']>;
  results: Array<Maybe<PurchaseOrderDueDateExportView>>;
};

export type PurchaseByProductExportView = {
  __typename?: 'PurchaseByProductExportView';
  additional_discount?: Maybe<Scalars['Float']['output']>;
  item_name?: Maybe<Scalars['String']['output']>;
  item_unique_id: Scalars['String']['output'];
  net_amount?: Maybe<Scalars['Float']['output']>;
  pre_discount_amount?: Maybe<Scalars['Float']['output']>;
  pre_vat_amount?: Maybe<Scalars['Float']['output']>;
  qty?: Maybe<Scalars['Float']['output']>;
  total_amount?: Maybe<Scalars['Float']['output']>;
  uom_name?: Maybe<Scalars['String']['output']>;
  vat_amount?: Maybe<Scalars['Float']['output']>;
  withholding_tax_amount?: Maybe<Scalars['Float']['output']>;
};

export type PurchaseByProductExportViewAggridOutput = {
  __typename?: 'PurchaseByProductExportViewAggridOutput';
  count?: Maybe<Scalars['Int']['output']>;
  results: Array<Maybe<PurchaseByProductExportView>>;
};

export type PurchaseBySupplierExportView = {
  __typename?: 'PurchaseBySupplierExportView';
  additional_discount?: Maybe<Scalars['Float']['output']>;
  net_amount?: Maybe<Scalars['Float']['output']>;
  post_discount_amount?: Maybe<Scalars['Float']['output']>;
  pre_vat_amount?: Maybe<Scalars['Float']['output']>;
  supplier_name?: Maybe<Scalars['String']['output']>;
  supplier_unique_id: Scalars['String']['output'];
  total_amount?: Maybe<Scalars['Float']['output']>;
  total_document?: Maybe<Scalars['Int']['output']>;
  vat_amount?: Maybe<Scalars['Float']['output']>;
  withholding_tax_amount?: Maybe<Scalars['Float']['output']>;
};

export type PurchaseBySupplierExportViewsAggridOutput = {
  __typename?: 'PurchaseBySupplierExportViewsAggridOutput';
  count?: Maybe<Scalars['Int']['output']>;
  results: Array<Maybe<PurchaseBySupplierExportView>>;
};

export enum PurchaseDocumentType {
  PurchaseOrder = 'purchase_order',
  PurchaseReturn = 'purchase_return'
}

export enum PurchaseExportType {
  PurchaseOrderByDueDate = 'purchase_order_by_due_date',
  PurchaseOrderByProduct = 'purchase_order_by_product',
  PurchaseOrderBySupplier = 'purchase_order_by_supplier',
  PurchaseOrderExport = 'purchase_order_export',
  PurchaseReturnExport = 'purchase_return_export'
}

export type PurchaseItemInput = {
  additional_discount?: InputMaybe<Scalars['Float']['input']>;
  barcode: Scalars['String']['input'];
  discount?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  item_desc?: InputMaybe<Scalars['String']['input']>;
  item_id: Scalars['Int']['input'];
  item_img_url?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  item_name: Scalars['String']['input'];
  item_unique_id: Scalars['String']['input'];
  net_amount?: InputMaybe<Scalars['Float']['input']>;
  po_qty?: InputMaybe<Scalars['Float']['input']>;
  post_discount_amount?: InputMaybe<Scalars['Float']['input']>;
  pre_discount_amount?: InputMaybe<Scalars['Float']['input']>;
  pre_vat_amount?: InputMaybe<Scalars['Float']['input']>;
  price_per_unit?: InputMaybe<Scalars['Float']['input']>;
  qty: Scalars['Float']['input'];
  qty_issued?: InputMaybe<Scalars['Float']['input']>;
  qty_ordered?: InputMaybe<Scalars['Float']['input']>;
  qty_received?: InputMaybe<Scalars['Float']['input']>;
  qty_returned?: InputMaybe<Scalars['Float']['input']>;
  reference_document_type?: InputMaybe<ReferenceDocumentType>;
  reference_line_item?: InputMaybe<Scalars['Json']['input']>;
  reference_unique_id: Scalars['String']['input'];
  remark?: InputMaybe<Scalars['String']['input']>;
  rs_qty?: InputMaybe<Scalars['Float']['input']>;
  stock_qty?: InputMaybe<Scalars['Int']['input']>;
  total_amount?: InputMaybe<Scalars['Float']['input']>;
  traceability: Traceability;
  unique_id: Scalars['String']['input'];
  uom?: InputMaybe<Scalars['Json']['input']>;
  uom_conversion_list?: InputMaybe<Array<InputMaybe<Scalars['Json']['input']>>>;
  uom_id?: InputMaybe<Scalars['Int']['input']>;
  uom_name?: InputMaybe<Scalars['String']['input']>;
  vat_amount?: InputMaybe<Scalars['Float']['input']>;
  vat_percentage?: InputMaybe<Scalars['String']['input']>;
  wait_receive_qty?: InputMaybe<Scalars['Float']['input']>;
  withholding_tax_type?: InputMaybe<Scalars['String']['input']>;
  withholding_tax_value?: InputMaybe<Scalars['Float']['input']>;
};

export type PurchaseItemList = {
  __typename?: 'PurchaseItemList';
  additional_discount?: Maybe<Scalars['Float']['output']>;
  barcode: Scalars['String']['output'];
  discount?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  item_desc?: Maybe<Scalars['String']['output']>;
  item_id: Scalars['Int']['output'];
  item_img_url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  item_name: Scalars['String']['output'];
  item_unique_id: Scalars['String']['output'];
  net_amount?: Maybe<Scalars['Float']['output']>;
  po_qty?: Maybe<Scalars['Float']['output']>;
  post_discount_amount?: Maybe<Scalars['Float']['output']>;
  pre_discount_amount?: Maybe<Scalars['Float']['output']>;
  pre_vat_amount?: Maybe<Scalars['Float']['output']>;
  price_per_unit?: Maybe<Scalars['Float']['output']>;
  qty: Scalars['Float']['output'];
  qty_issued?: Maybe<Scalars['Float']['output']>;
  qty_ordered?: Maybe<Scalars['Float']['output']>;
  qty_received?: Maybe<Scalars['Float']['output']>;
  qty_returned?: Maybe<Scalars['Float']['output']>;
  reference_document_type?: Maybe<ReferenceDocumentType>;
  reference_line_item?: Maybe<Scalars['Json']['output']>;
  reference_unique_id: Scalars['String']['output'];
  remark?: Maybe<Scalars['String']['output']>;
  rs_qty?: Maybe<Scalars['Float']['output']>;
  stock_qty?: Maybe<Scalars['Int']['output']>;
  total_amount?: Maybe<Scalars['Float']['output']>;
  traceability?: Maybe<Traceability>;
  unique_id: Scalars['String']['output'];
  uom?: Maybe<Scalars['Json']['output']>;
  uom_conversion_list?: Maybe<Array<Maybe<Scalars['Json']['output']>>>;
  uom_id?: Maybe<Scalars['Int']['output']>;
  uom_name?: Maybe<Scalars['String']['output']>;
  vat_amount?: Maybe<Scalars['Float']['output']>;
  vat_percentage?: Maybe<Scalars['String']['output']>;
  wait_receive_qty?: Maybe<Scalars['Float']['output']>;
  withholding_tax_type?: Maybe<Scalars['String']['output']>;
  withholding_tax_value?: Maybe<Scalars['Float']['output']>;
};

export enum PurchaseModelType {
  PurchaseOrder = 'purchase_order',
  PurchaseReturn = 'purchase_return'
}

export type PurchaseOrder = {
  __typename?: 'PurchaseOrder';
  additional_discount?: Maybe<Scalars['Float']['output']>;
  additional_discount_type?: Maybe<AdditionalDiscountType>;
  aggrid_status?: Maybe<Scalars['String']['output']>;
  created_by?: Maybe<CreatorObject>;
  created_date: Scalars['DateTime']['output'];
  credit_day?: Maybe<Scalars['Int']['output']>;
  destination_warehouse?: Maybe<Warehouse>;
  destination_warehouse_id?: Maybe<Scalars['Int']['output']>;
  due_date?: Maybe<Scalars['DateTime']['output']>;
  expected_date?: Maybe<Scalars['DateTime']['output']>;
  flag_status?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['Int']['output'];
  issue_date?: Maybe<Scalars['DateTime']['output']>;
  item_list?: Maybe<Array<PurchaseItemList>>;
  last_updated_by?: Maybe<CreatorObject>;
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  main_status?: Maybe<Scalars['String']['output']>;
  net_amount?: Maybe<Scalars['Float']['output']>;
  post_discount_amount?: Maybe<Scalars['Float']['output']>;
  pre_vat_amount?: Maybe<Scalars['Float']['output']>;
  price_vat_type?: Maybe<PriceVatType>;
  reference_no?: Maybe<Scalars['String']['output']>;
  related_user_list?: Maybe<Array<Scalars['Json']['output']>>;
  remark?: Maybe<Scalars['String']['output']>;
  shipping_cost?: Maybe<Scalars['Float']['output']>;
  sub_status?: Maybe<Scalars['String']['output']>;
  supplier_details?: Maybe<Scalars['Json']['output']>;
  supplier_unique_id?: Maybe<Scalars['String']['output']>;
  tag_id_list?: Maybe<Array<Scalars['Int']['output']>>;
  tag_list?: Maybe<Array<Tag>>;
  total_amount?: Maybe<Scalars['Float']['output']>;
  unique_id: Scalars['String']['output'];
  vat_0_percent_amount?: Maybe<Scalars['Float']['output']>;
  vat_7_percent_amount?: Maybe<Scalars['Float']['output']>;
  vat_amount?: Maybe<Scalars['Float']['output']>;
  vat_exempted_amount?: Maybe<Scalars['Float']['output']>;
  withholding_tax_amount?: Maybe<Scalars['Float']['output']>;
  within_date?: Maybe<Scalars['Date']['output']>;
};

export type PurchaseOrderDueDateExportView = {
  __typename?: 'PurchaseOrderDueDateExportView';
  additional_discount?: Maybe<Scalars['Float']['output']>;
  due_date?: Maybe<Scalars['DateTime']['output']>;
  net_amount?: Maybe<Scalars['Float']['output']>;
  post_discount_amount?: Maybe<Scalars['Float']['output']>;
  pre_vat_amount?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  supplier_name?: Maybe<Scalars['String']['output']>;
  supplier_unique_id?: Maybe<Scalars['String']['output']>;
  total_amount?: Maybe<Scalars['Float']['output']>;
  unique_id: Scalars['String']['output'];
  vat_amount?: Maybe<Scalars['Float']['output']>;
  withholding_tax_amount?: Maybe<Scalars['Float']['output']>;
};

export type PurchaseOrderExportView = {
  __typename?: 'PurchaseOrderExportView';
  additional_discount?: Maybe<Scalars['Float']['output']>;
  additional_discount_type?: Maybe<AdditionalDiscountType>;
  billing_address_country?: Maybe<Scalars['String']['output']>;
  billing_address_district?: Maybe<Scalars['String']['output']>;
  billing_address_name?: Maybe<Scalars['String']['output']>;
  billing_address_postal_code?: Maybe<Scalars['String']['output']>;
  billing_address_province?: Maybe<Scalars['String']['output']>;
  billing_address_sub_district?: Maybe<Scalars['String']['output']>;
  created_by?: Maybe<Scalars['String']['output']>;
  created_date?: Maybe<Scalars['DateTime']['output']>;
  credit_day?: Maybe<Scalars['Int']['output']>;
  delivery_address_country?: Maybe<Scalars['String']['output']>;
  delivery_address_district?: Maybe<Scalars['String']['output']>;
  delivery_address_name?: Maybe<Scalars['String']['output']>;
  delivery_address_postal_code?: Maybe<Scalars['String']['output']>;
  delivery_address_province?: Maybe<Scalars['String']['output']>;
  delivery_address_sub_district?: Maybe<Scalars['String']['output']>;
  destination_warehouse_unique_id?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<Scalars['Float']['output']>;
  due_date?: Maybe<Scalars['DateTime']['output']>;
  expected_date?: Maybe<Scalars['DateTime']['output']>;
  external_reference_no?: Maybe<Scalars['String']['output']>;
  issue_date?: Maybe<Scalars['DateTime']['output']>;
  item_name?: Maybe<Scalars['String']['output']>;
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  net_amount?: Maybe<Scalars['Float']['output']>;
  po_qty?: Maybe<Scalars['Float']['output']>;
  post_discount_amount?: Maybe<Scalars['Float']['output']>;
  pre_vat_amount?: Maybe<Scalars['Float']['output']>;
  price_per_unit?: Maybe<Scalars['Float']['output']>;
  price_vat_type?: Maybe<PriceVatType>;
  qty?: Maybe<Scalars['Float']['output']>;
  reference_document?: Maybe<Array<Maybe<Scalars['Json']['output']>>>;
  related_user_list?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  remark?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  stock_qty?: Maybe<Scalars['Float']['output']>;
  supplier_email?: Maybe<Scalars['String']['output']>;
  supplier_fax?: Maybe<Scalars['String']['output']>;
  supplier_identity_no?: Maybe<Scalars['String']['output']>;
  supplier_name?: Maybe<Scalars['String']['output']>;
  supplier_phone?: Maybe<Scalars['String']['output']>;
  supplier_unique_id?: Maybe<Scalars['String']['output']>;
  total_amount?: Maybe<Scalars['Float']['output']>;
  unique_id: Scalars['String']['output'];
  uom_name?: Maybe<Scalars['String']['output']>;
  vat_amount?: Maybe<Scalars['Float']['output']>;
  vat_percentage?: Maybe<Scalars['Float']['output']>;
  withholding_tax_amount?: Maybe<Scalars['Float']['output']>;
  withholding_tax_type?: Maybe<Scalars['Float']['output']>;
  within_date?: Maybe<Scalars['DateTime']['output']>;
};

export type PurchaseOrderInput = {
  additional_discount?: InputMaybe<Scalars['Float']['input']>;
  additional_discount_type?: InputMaybe<AdditionalDiscountType>;
  aggrid_status?: InputMaybe<Scalars['String']['input']>;
  created_by: CreatorInputObject;
  credit_day?: InputMaybe<Scalars['Int']['input']>;
  destination_warehouse_id?: InputMaybe<Scalars['Int']['input']>;
  due_date?: InputMaybe<Scalars['Date']['input']>;
  expected_date?: InputMaybe<Scalars['Date']['input']>;
  flag_status?: InputMaybe<Array<Scalars['String']['input']>>;
  issue_date?: InputMaybe<Scalars['Date']['input']>;
  item_list: Array<PurchaseItemInput>;
  last_updated_by?: InputMaybe<CreatorInputObject>;
  last_updated_date?: InputMaybe<Scalars['Date']['input']>;
  main_status?: InputMaybe<Scalars['String']['input']>;
  net_amount?: InputMaybe<Scalars['Float']['input']>;
  post_discount_amount?: InputMaybe<Scalars['Float']['input']>;
  pre_vat_amount?: InputMaybe<Scalars['Float']['input']>;
  price_vat_type?: InputMaybe<PriceVatType>;
  reference_document_list?: InputMaybe<Array<InputMaybe<ReferenceDocumentListInput>>>;
  reference_no?: InputMaybe<Scalars['String']['input']>;
  related_user_list?: InputMaybe<Array<InputMaybe<RelatedUserList>>>;
  remark?: InputMaybe<Scalars['String']['input']>;
  shipping_cost?: InputMaybe<Scalars['Float']['input']>;
  sub_status?: InputMaybe<Scalars['String']['input']>;
  supplier_details?: InputMaybe<Scalars['Json']['input']>;
  supplier_unique_id?: InputMaybe<Scalars['String']['input']>;
  tag_id_list?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  tag_list?: InputMaybe<Array<InputMaybe<Scalars['Json']['input']>>>;
  total_amount?: InputMaybe<Scalars['Float']['input']>;
  unique_id: Scalars['String']['input'];
  vat_0_percent_amount?: InputMaybe<Scalars['Float']['input']>;
  vat_7_percent_amount?: InputMaybe<Scalars['Float']['input']>;
  vat_amount?: InputMaybe<Scalars['Float']['input']>;
  vat_exempted_amount?: InputMaybe<Scalars['Float']['input']>;
  withholding_tax_amount?: InputMaybe<Scalars['Float']['input']>;
  within_date?: InputMaybe<Scalars['Date']['input']>;
};

export type PurchaseOrderUpdateInput = {
  additional_discount?: InputMaybe<Scalars['Float']['input']>;
  additional_discount_type?: InputMaybe<AdditionalDiscountType>;
  aggrid_status?: InputMaybe<Scalars['String']['input']>;
  credit_day?: InputMaybe<Scalars['Int']['input']>;
  destination_warehouse_id?: InputMaybe<Scalars['Int']['input']>;
  due_date?: InputMaybe<Scalars['Date']['input']>;
  expected_date?: InputMaybe<Scalars['Date']['input']>;
  flag_status?: InputMaybe<Array<Scalars['String']['input']>>;
  issue_date?: InputMaybe<Scalars['Date']['input']>;
  item_list?: InputMaybe<Array<InputMaybe<PurchaseItemInput>>>;
  last_updated_by?: InputMaybe<CreatorInputObject>;
  last_updated_date?: InputMaybe<Scalars['Date']['input']>;
  main_status?: InputMaybe<Scalars['String']['input']>;
  net_amount?: InputMaybe<Scalars['Float']['input']>;
  post_discount_amount?: InputMaybe<Scalars['Float']['input']>;
  pre_vat_amount?: InputMaybe<Scalars['Float']['input']>;
  price_vat_type?: InputMaybe<PriceVatType>;
  reference_document_list?: InputMaybe<Array<InputMaybe<ReferenceDocumentListInput>>>;
  reference_no?: InputMaybe<Scalars['String']['input']>;
  related_user_list?: InputMaybe<Array<InputMaybe<RelatedUserList>>>;
  remark?: InputMaybe<Scalars['String']['input']>;
  shipping_cost?: InputMaybe<Scalars['Float']['input']>;
  sub_status?: InputMaybe<Scalars['String']['input']>;
  supplier_details?: InputMaybe<Scalars['Json']['input']>;
  supplier_unique_id?: InputMaybe<Scalars['String']['input']>;
  tag_id_list?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  tag_list?: InputMaybe<Array<InputMaybe<Scalars['Json']['input']>>>;
  total_amount?: InputMaybe<Scalars['Float']['input']>;
  unique_id?: InputMaybe<Scalars['String']['input']>;
  vat_0_percent_amount?: InputMaybe<Scalars['Float']['input']>;
  vat_7_percent_amount?: InputMaybe<Scalars['Float']['input']>;
  vat_amount?: InputMaybe<Scalars['Float']['input']>;
  vat_exempted_amount?: InputMaybe<Scalars['Float']['input']>;
  withholding_tax_amount?: InputMaybe<Scalars['Float']['input']>;
  within_date?: InputMaybe<Scalars['Date']['input']>;
};

export type PurchaseOrderView = {
  __typename?: 'PurchaseOrderView';
  created_by?: Maybe<Scalars['String']['output']>;
  created_by_object?: Maybe<Scalars['Json']['output']>;
  created_date?: Maybe<Scalars['DateTime']['output']>;
  destination_warehouse_id?: Maybe<Scalars['Int']['output']>;
  destination_warehouse_name?: Maybe<Scalars['String']['output']>;
  destination_warehouse_unique_id?: Maybe<Scalars['String']['output']>;
  due_date?: Maybe<Scalars['DateTime']['output']>;
  expected_date?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  issue_date?: Maybe<Scalars['DateTime']['output']>;
  item_list?: Maybe<Array<Maybe<Scalars['Json']['output']>>>;
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  net_amount?: Maybe<Scalars['Float']['output']>;
  reference_document_list?: Maybe<Array<Scalars['String']['output']>>;
  reference_document_object_list?: Maybe<Array<Maybe<Scalars['Json']['output']>>>;
  reference_no?: Maybe<Scalars['String']['output']>;
  related_user_list?: Maybe<Array<Scalars['String']['output']>>;
  related_user_object_list?: Maybe<Array<Maybe<Scalars['Json']['output']>>>;
  remark?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  supplier_name?: Maybe<Scalars['String']['output']>;
  supplier_unique_id?: Maybe<Scalars['String']['output']>;
  unique_id: Scalars['String']['output'];
  within_date?: Maybe<Scalars['DateTime']['output']>;
};

export type PurchaseOrderViewAggrid = {
  __typename?: 'PurchaseOrderViewAggrid';
  count: Scalars['Int']['output'];
  results: Array<PurchaseOrderView>;
};

export type PurchaseReturn = {
  __typename?: 'PurchaseReturn';
  additional_discount?: Maybe<Scalars['Float']['output']>;
  additional_discount_type?: Maybe<AdditionalDiscountType>;
  aggrid_status?: Maybe<Scalars['String']['output']>;
  created_by?: Maybe<CreatorObject>;
  created_date: Scalars['DateTime']['output'];
  credit_day?: Maybe<Scalars['Int']['output']>;
  delivery_date?: Maybe<Scalars['DateTime']['output']>;
  flag_status?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['Int']['output'];
  issue_date?: Maybe<Scalars['DateTime']['output']>;
  item_list?: Maybe<Array<PurchaseItemList>>;
  last_updated_by?: Maybe<CreatorObject>;
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  main_status?: Maybe<Scalars['String']['output']>;
  net_amount?: Maybe<Scalars['Float']['output']>;
  post_discount_amount?: Maybe<Scalars['Float']['output']>;
  pre_vat_amount?: Maybe<Scalars['Float']['output']>;
  price_vat_type?: Maybe<PriceVatType>;
  reason_to_return?: Maybe<Scalars['String']['output']>;
  reference_document_list?: Maybe<Array<ReferenceDocumentList>>;
  reference_no: Scalars['String']['output'];
  related_user_list?: Maybe<Array<Scalars['Json']['output']>>;
  remark?: Maybe<Scalars['String']['output']>;
  sub_status?: Maybe<Scalars['String']['output']>;
  supplier_details?: Maybe<Scalars['Json']['output']>;
  supplier_unique_id?: Maybe<Scalars['String']['output']>;
  total_amount?: Maybe<Scalars['Float']['output']>;
  unique_id: Scalars['String']['output'];
  vat_0_percent_amount?: Maybe<Scalars['Float']['output']>;
  vat_7_percent_amount?: Maybe<Scalars['Float']['output']>;
  vat_amount?: Maybe<Scalars['Float']['output']>;
  vat_exempted_amount?: Maybe<Scalars['Float']['output']>;
  withholding_tax_amount?: Maybe<Scalars['Float']['output']>;
};

export type PurchaseReturnCreateInput = {
  additional_discount?: InputMaybe<Scalars['Float']['input']>;
  additional_discount_type?: InputMaybe<AdditionalDiscountType>;
  aggrid_status?: InputMaybe<Scalars['String']['input']>;
  created_by?: InputMaybe<CreatorInputObject>;
  credit_day?: InputMaybe<Scalars['Int']['input']>;
  delivery_date?: InputMaybe<Scalars['DateTime']['input']>;
  flag_status?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  issue_date?: InputMaybe<Scalars['DateTime']['input']>;
  item_list?: InputMaybe<Array<InputMaybe<PurchaseItemInput>>>;
  last_updated_by?: InputMaybe<CreatorInputObject>;
  main_status?: InputMaybe<Scalars['String']['input']>;
  net_amount?: InputMaybe<Scalars['Float']['input']>;
  post_discount_amount?: InputMaybe<Scalars['Float']['input']>;
  pre_vat_amount?: InputMaybe<Scalars['Float']['input']>;
  price_vat_type?: InputMaybe<PriceVatType>;
  reason_to_return?: InputMaybe<Scalars['String']['input']>;
  reference_document_list?: InputMaybe<Array<InputMaybe<ReferenceDocumentListInput>>>;
  reference_no: Scalars['String']['input'];
  related_user_list?: InputMaybe<Array<InputMaybe<RelatedUserList>>>;
  remark?: InputMaybe<Scalars['String']['input']>;
  sub_status?: InputMaybe<Scalars['String']['input']>;
  supplier_details?: InputMaybe<Scalars['Json']['input']>;
  supplier_unique_id?: InputMaybe<Scalars['String']['input']>;
  total_amount?: InputMaybe<Scalars['Float']['input']>;
  unique_id: Scalars['String']['input'];
  vat_0_percent_amount?: InputMaybe<Scalars['Float']['input']>;
  vat_7_percent_amount?: InputMaybe<Scalars['Float']['input']>;
  vat_amount?: InputMaybe<Scalars['Float']['input']>;
  vat_exempted_amount?: InputMaybe<Scalars['Float']['input']>;
  withholding_tax_amount?: InputMaybe<Scalars['Float']['input']>;
};

export type PurchaseReturnExportView = {
  __typename?: 'PurchaseReturnExportView';
  additional_discount?: Maybe<Scalars['Float']['output']>;
  additional_discount_type?: Maybe<AdditionalDiscountType>;
  billing_address_country?: Maybe<Scalars['String']['output']>;
  billing_address_district?: Maybe<Scalars['String']['output']>;
  billing_address_name?: Maybe<Scalars['String']['output']>;
  billing_address_postal_code?: Maybe<Scalars['String']['output']>;
  billing_address_province?: Maybe<Scalars['String']['output']>;
  billing_address_sub_district?: Maybe<Scalars['String']['output']>;
  created_by?: Maybe<Scalars['String']['output']>;
  created_date?: Maybe<Scalars['DateTime']['output']>;
  credit_day?: Maybe<Scalars['Int']['output']>;
  delivery_address_country?: Maybe<Scalars['String']['output']>;
  delivery_address_district?: Maybe<Scalars['String']['output']>;
  delivery_address_name?: Maybe<Scalars['String']['output']>;
  delivery_address_postal_code?: Maybe<Scalars['String']['output']>;
  delivery_address_province?: Maybe<Scalars['String']['output']>;
  delivery_address_sub_district?: Maybe<Scalars['String']['output']>;
  delivery_date?: Maybe<Scalars['DateTime']['output']>;
  discount?: Maybe<Scalars['Float']['output']>;
  external_reference_no?: Maybe<Scalars['String']['output']>;
  issue_date?: Maybe<Scalars['DateTime']['output']>;
  item_name?: Maybe<Scalars['String']['output']>;
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  net_amount?: Maybe<Scalars['Float']['output']>;
  post_discount_amount?: Maybe<Scalars['Float']['output']>;
  pre_vat_amount?: Maybe<Scalars['Float']['output']>;
  price_per_unit?: Maybe<Scalars['Float']['output']>;
  price_vat_type?: Maybe<PriceVatType>;
  qty?: Maybe<Scalars['Float']['output']>;
  reason_to_return?: Maybe<Scalars['String']['output']>;
  reference_document?: Maybe<Array<Maybe<Scalars['Json']['output']>>>;
  related_user_list?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  remark?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  stock_qty?: Maybe<Scalars['Float']['output']>;
  supplier_email?: Maybe<Scalars['String']['output']>;
  supplier_fax?: Maybe<Scalars['String']['output']>;
  supplier_identity_no?: Maybe<Scalars['String']['output']>;
  supplier_name?: Maybe<Scalars['String']['output']>;
  supplier_phone?: Maybe<Scalars['String']['output']>;
  supplier_unique_id?: Maybe<Scalars['String']['output']>;
  total_amount?: Maybe<Scalars['Float']['output']>;
  unique_id: Scalars['String']['output'];
  uom_name?: Maybe<Scalars['String']['output']>;
  vat_amount?: Maybe<Scalars['Float']['output']>;
  vat_percentage?: Maybe<Scalars['Float']['output']>;
  withholding_tax_amount?: Maybe<Scalars['Float']['output']>;
  withholding_tax_type?: Maybe<Scalars['Float']['output']>;
};

export type PurchaseReturnUpdateInput = {
  additional_discount?: InputMaybe<Scalars['Float']['input']>;
  additional_discount_type?: InputMaybe<AdditionalDiscountType>;
  aggrid_status?: InputMaybe<Scalars['String']['input']>;
  credit_day?: InputMaybe<Scalars['Int']['input']>;
  delivery_date?: InputMaybe<Scalars['DateTime']['input']>;
  flag_status?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  issue_date?: InputMaybe<Scalars['DateTime']['input']>;
  item_list?: InputMaybe<Array<InputMaybe<PurchaseItemInput>>>;
  last_updated_by?: InputMaybe<CreatorInputObject>;
  last_updated_date?: InputMaybe<Scalars['Date']['input']>;
  main_status?: InputMaybe<Scalars['String']['input']>;
  net_amount?: InputMaybe<Scalars['Float']['input']>;
  post_discount_amount?: InputMaybe<Scalars['Float']['input']>;
  pre_vat_amount?: InputMaybe<Scalars['Float']['input']>;
  price_vat_type?: InputMaybe<PriceVatType>;
  reason_to_return?: InputMaybe<Scalars['String']['input']>;
  reference_document_list?: InputMaybe<Array<InputMaybe<ReferenceDocumentListInput>>>;
  reference_no?: InputMaybe<Scalars['String']['input']>;
  related_user_list?: InputMaybe<Array<InputMaybe<RelatedUserList>>>;
  remark?: InputMaybe<Scalars['String']['input']>;
  sub_status?: InputMaybe<Scalars['String']['input']>;
  supplier_details?: InputMaybe<Scalars['Json']['input']>;
  supplier_unique_id?: InputMaybe<Scalars['String']['input']>;
  total_amount?: InputMaybe<Scalars['Float']['input']>;
  unique_id?: InputMaybe<Scalars['String']['input']>;
  vat_0_percent_amount?: InputMaybe<Scalars['Float']['input']>;
  vat_7_percent_amount?: InputMaybe<Scalars['Float']['input']>;
  vat_amount?: InputMaybe<Scalars['Float']['input']>;
  vat_exempted_amount?: InputMaybe<Scalars['Float']['input']>;
  withholding_tax_amount?: InputMaybe<Scalars['Float']['input']>;
};

export type PurchaseReturnView = {
  __typename?: 'PurchaseReturnView';
  created_by?: Maybe<Scalars['String']['output']>;
  created_by_object?: Maybe<Scalars['Json']['output']>;
  created_date?: Maybe<Scalars['DateTime']['output']>;
  delivery_date?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  issue_date?: Maybe<Scalars['DateTime']['output']>;
  item_list?: Maybe<Array<Maybe<Scalars['Json']['output']>>>;
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  net_amount?: Maybe<Scalars['Float']['output']>;
  reason_to_return?: Maybe<Scalars['String']['output']>;
  reference_document_list?: Maybe<Array<Scalars['String']['output']>>;
  reference_document_object_list?: Maybe<Array<Maybe<Scalars['Json']['output']>>>;
  reference_no?: Maybe<Scalars['String']['output']>;
  related_user_list?: Maybe<Array<Scalars['String']['output']>>;
  related_user_object_list?: Maybe<Array<Maybe<Scalars['Json']['output']>>>;
  remark?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  supplier_name?: Maybe<Scalars['String']['output']>;
  supplier_unique_id?: Maybe<Scalars['String']['output']>;
  unique_id: Scalars['String']['output'];
};

export type PurchaseReturnViewAggrid = {
  __typename?: 'PurchaseReturnViewAggrid';
  count: Scalars['Int']['output'];
  results: Array<PurchaseReturnView>;
};

export type PurchaseUniqueInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  unique_id?: InputMaybe<Scalars['String']['input']>;
};

export type Query = {
  __typename?: 'Query';
  GenerateExport: Scalars['String']['output'];
  PurchaseByDueDateExportViewsAggrid: PurchaseByDueDateExportViewsAggridOutput;
  PurchaseByProductExportViewAggrid: PurchaseByProductExportViewAggridOutput;
  PurchaseBySupplierExportViewsAggrid: PurchaseBySupplierExportViewsAggridOutput;
  PurchaseOrderFindManyAggrid: CustomPurchaseOrder;
  PurchaseOrderFindUnique: PurchaseOrder;
  PurchaseOrderViewsAggrid: PurchaseOrderViewAggrid;
  PurchaseOrdersFindAll?: Maybe<Array<PurchaseOrder>>;
  PurchaseReturnViewsAggrid: PurchaseReturnViewAggrid;
  UniqueIdGenerate: Scalars['String']['output'];
  UniqueIdIsExist: Scalars['Boolean']['output'];
  purchaseReturnFindAll?: Maybe<Array<PurchaseReturn>>;
  purchaseReturnFindManyAggrid: CustomPurchaseReturn;
  purchaseReturnFindUnique: PurchaseReturn;
  test?: Maybe<Scalars['String']['output']>;
};


export type QueryGenerateExportArgs = {
  input?: InputMaybe<ExportGenerateInput>;
};


export type QueryPurchaseByDueDateExportViewsAggridArgs = {
  aggridInput?: InputMaybe<Scalars['AnyAggridInput']['input']>;
};


export type QueryPurchaseByProductExportViewAggridArgs = {
  aggridInput?: InputMaybe<Scalars['AnyAggridInput']['input']>;
};


export type QueryPurchaseBySupplierExportViewsAggridArgs = {
  aggridInput?: InputMaybe<Scalars['AnyAggridInput']['input']>;
};


export type QueryPurchaseOrderFindManyAggridArgs = {
  aggridInput?: InputMaybe<Scalars['AnyAggridInput']['input']>;
};


export type QueryPurchaseOrderFindUniqueArgs = {
  uniqueInput?: InputMaybe<PurchaseUniqueInput>;
};


export type QueryPurchaseOrderViewsAggridArgs = {
  aggridInput?: InputMaybe<Scalars['AnyAggridInput']['input']>;
};


export type QueryPurchaseReturnViewsAggridArgs = {
  aggridInput?: InputMaybe<Scalars['AnyAggridInput']['input']>;
};


export type QueryUniqueIdGenerateArgs = {
  modelType: PurchaseModelType;
};


export type QueryUniqueIdIsExistArgs = {
  modelType: PurchaseModelType;
  uniqueId: Scalars['String']['input'];
};


export type QueryPurchaseReturnFindManyAggridArgs = {
  aggridInput?: InputMaybe<Scalars['AnyAggridInput']['input']>;
};


export type QueryPurchaseReturnFindUniqueArgs = {
  uniqueInput?: InputMaybe<PurchaseUniqueInput>;
};

export type ReferenceDocumentList = {
  __typename?: 'ReferenceDocumentList';
  document_id?: Maybe<Scalars['Int']['output']>;
  document_type?: Maybe<PurchaseDocumentType>;
  document_unique_id?: Maybe<Scalars['String']['output']>;
};

export type ReferenceDocumentListInput = {
  document_id?: InputMaybe<Scalars['Int']['input']>;
  document_type?: InputMaybe<PurchaseDocumentType>;
  document_unique_id?: InputMaybe<Scalars['String']['input']>;
};

export enum ReferenceDocumentType {
  PurchaseOrder = 'purchase_order',
  PurchaseReturn = 'purchase_return'
}

export type RelatedUser = {
  __typename?: 'RelatedUser';
  department?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  img_url?: Maybe<Scalars['String']['output']>;
  is_active?: Maybe<Scalars['Int']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['String']['output']>;
  title_name?: Maybe<Scalars['String']['output']>;
  user_unique_id?: Maybe<Scalars['String']['output']>;
};

export type RelatedUserList = {
  department?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  img_url?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  is_active?: InputMaybe<Scalars['Int']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  title_name?: InputMaybe<Scalars['String']['input']>;
  user_unique_id?: InputMaybe<Scalars['String']['input']>;
};

export type SalesCustomerInputObject = {
  billing_address?: InputMaybe<AddressInputObject>;
  customer_id?: InputMaybe<Scalars['Int']['input']>;
  customer_name?: InputMaybe<Scalars['String']['input']>;
  customer_unique_id?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  fax?: InputMaybe<Scalars['String']['input']>;
  identity_no?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type SalesCustomerObject = {
  __typename?: 'SalesCustomerObject';
  billing_address?: Maybe<AddressObject>;
  customer_id?: Maybe<Scalars['Int']['output']>;
  customer_name?: Maybe<Scalars['String']['output']>;
  customer_unique_id?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  fax?: Maybe<Scalars['String']['output']>;
  identity_no?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type SelectOptionById = {
  __typename?: 'SelectOptionById';
  label: Scalars['String']['output'];
  value: Scalars['Int']['output'];
};

export enum SortOrder {
  Asc = 'asc',
  Desc = 'desc'
}

export type SpectaQlOption = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type Tag = {
  __typename?: 'Tag';
  document_type: TagDocumentType;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export enum TagDocumentType {
  Batch = 'batch',
  CashSales = 'cash_sales',
  Contact = 'contact',
  CreditNote = 'credit_note',
  CustomerDeposit = 'customer_deposit',
  DeliveryOrder = 'delivery_order',
  DeliveryTrip = 'delivery_trip',
  Employee = 'employee',
  Event = 'event',
  GoodsAdjust = 'goods_adjust',
  GoodsIssue = 'goods_issue',
  GoodsReceive = 'goods_receive',
  GoodsTransfer = 'goods_transfer',
  Inventory = 'inventory',
  Item = 'item',
  PaymentMade = 'payment_made',
  PaymentReceive = 'payment_receive',
  Project = 'project',
  Promotion = 'promotion',
  Purchase = 'purchase',
  PurchaseInvoice = 'purchase_invoice',
  PurchaseOrder = 'purchase_order',
  PurchaseRequest = 'purchase_request',
  PurchaseReturn = 'purchase_return',
  Quotation = 'quotation',
  Role = 'role',
  Sale = 'sale',
  SalesInvoice = 'sales_invoice',
  SalesOrder = 'sales_order',
  SalesReturn = 'sales_return',
  Serial = 'serial',
  Task = 'task'
}

export enum Traceability {
  Lot = 'lot',
  Normal = 'normal',
  Serial = 'serial'
}

export type Warehouse = {
  __typename?: 'Warehouse';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  unique_id: Scalars['String']['output'];
  warehouse_level_1_list?: Maybe<Array<WarehouseLevel1>>;
};

export type WarehouseLevel1 = {
  __typename?: 'WarehouseLevel1';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  warehouse: Warehouse;
  warehouse_level_2_list?: Maybe<Array<WarehouseLevel2>>;
};

export type WarehouseLevel2 = {
  __typename?: 'WarehouseLevel2';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  warehouse_level_1: WarehouseLevel1;
  warehouse_level_3_list?: Maybe<Array<WarehouseLevel3>>;
};

export type WarehouseLevel3 = {
  __typename?: 'WarehouseLevel3';
  bin_location_list?: Maybe<Array<BinLocation>>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  warehouse_level_2: WarehouseLevel2;
};

export type PurchaseOrderCreateMutationVariables = Exact<{
  data?: InputMaybe<PurchaseOrderInput>;
}>;


export type PurchaseOrderCreateMutation = { __typename?: 'Mutation', PurchaseOrderCreate?: { __typename?: 'PurchaseOrder', id: number, unique_id: string, reference_no?: string | null, created_date: any, last_updated_date?: any | null, issue_date?: any | null, expected_date?: any | null, due_date?: any | null, credit_day?: number | null, within_date?: any | null, destination_warehouse_id?: number | null, related_user_list?: Array<any> | null, supplier_unique_id?: string | null, supplier_details?: any | null, price_vat_type?: PriceVatType | null, pre_vat_amount?: number | null, shipping_cost?: number | null, additional_discount?: number | null, additional_discount_type?: AdditionalDiscountType | null, post_discount_amount?: number | null, vat_exempted_amount?: number | null, vat_0_percent_amount?: number | null, vat_7_percent_amount?: number | null, vat_amount?: number | null, net_amount?: number | null, withholding_tax_amount?: number | null, total_amount?: number | null, remark?: string | null, main_status?: string | null, sub_status?: string | null, flag_status?: Array<string> | null, aggrid_status?: string | null, tag_id_list?: Array<number> | null, created_by?: { __typename?: 'CreatorObject', user_unique_id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, img_url?: Array<string> | null } | null, last_updated_by?: { __typename?: 'CreatorObject', user_id?: number | null, user_unique_id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, img_url?: Array<string> | null } | null, destination_warehouse?: { __typename?: 'Warehouse', id: number, unique_id: string, name: string } | null, tag_list?: Array<{ __typename?: 'Tag', id: number, name: string, document_type: TagDocumentType }> | null, item_list?: Array<{ __typename?: 'PurchaseItemList', id?: number | null, unique_id: string, reference_unique_id: string, reference_line_item?: any | null, reference_document_type?: ReferenceDocumentType | null, item_id: number, item_unique_id: string, item_name: string, item_desc?: string | null, item_img_url?: Array<string | null> | null, traceability?: Traceability | null, barcode: string, qty: number, po_qty?: number | null, wait_receive_qty?: number | null, qty_ordered?: number | null, qty_received?: number | null, qty_returned?: number | null, qty_issued?: number | null, uom_id?: number | null, uom_name?: string | null, uom?: any | null, uom_conversion_list?: Array<any | null> | null, price_per_unit?: number | null, discount?: number | null, vat_percentage?: string | null, pre_vat_amount?: number | null, pre_discount_amount?: number | null, vat_amount?: number | null, additional_discount?: number | null, post_discount_amount?: number | null, net_amount?: number | null, total_amount?: number | null, stock_qty?: number | null, withholding_tax_type?: string | null, withholding_tax_value?: number | null, remark?: string | null }> | null } | null };

export type PurchaseOrderFindUniqueQueryVariables = Exact<{
  uniqueInput?: InputMaybe<PurchaseUniqueInput>;
}>;


export type PurchaseOrderFindUniqueQuery = { __typename?: 'Query', PurchaseOrderFindUnique: { __typename?: 'PurchaseOrder', id: number, unique_id: string, reference_no?: string | null, created_date: any, last_updated_date?: any | null, issue_date?: any | null, within_date?: any | null, expected_date?: any | null, due_date?: any | null, credit_day?: number | null, destination_warehouse_id?: number | null, related_user_list?: Array<any> | null, supplier_unique_id?: string | null, supplier_details?: any | null, price_vat_type?: PriceVatType | null, pre_vat_amount?: number | null, shipping_cost?: number | null, additional_discount?: number | null, additional_discount_type?: AdditionalDiscountType | null, post_discount_amount?: number | null, vat_exempted_amount?: number | null, vat_0_percent_amount?: number | null, vat_7_percent_amount?: number | null, vat_amount?: number | null, net_amount?: number | null, withholding_tax_amount?: number | null, total_amount?: number | null, remark?: string | null, main_status?: string | null, sub_status?: string | null, flag_status?: Array<string> | null, aggrid_status?: string | null, tag_id_list?: Array<number> | null, created_by?: { __typename?: 'CreatorObject', user_unique_id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, img_url?: Array<string> | null } | null, last_updated_by?: { __typename?: 'CreatorObject', user_id?: number | null, user_unique_id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, img_url?: Array<string> | null } | null, destination_warehouse?: { __typename?: 'Warehouse', id: number, unique_id: string, name: string } | null, tag_list?: Array<{ __typename?: 'Tag', id: number, name: string, document_type: TagDocumentType }> | null, item_list?: Array<{ __typename?: 'PurchaseItemList', id?: number | null, unique_id: string, reference_unique_id: string, reference_line_item?: any | null, reference_document_type?: ReferenceDocumentType | null, item_id: number, item_unique_id: string, item_name: string, item_desc?: string | null, item_img_url?: Array<string | null> | null, traceability?: Traceability | null, barcode: string, qty: number, po_qty?: number | null, wait_receive_qty?: number | null, qty_ordered?: number | null, qty_received?: number | null, qty_returned?: number | null, qty_issued?: number | null, uom_id?: number | null, uom_name?: string | null, uom?: any | null, uom_conversion_list?: Array<any | null> | null, price_per_unit?: number | null, discount?: number | null, vat_percentage?: string | null, pre_vat_amount?: number | null, pre_discount_amount?: number | null, vat_amount?: number | null, additional_discount?: number | null, post_discount_amount?: number | null, net_amount?: number | null, total_amount?: number | null, stock_qty?: number | null, withholding_tax_type?: string | null, withholding_tax_value?: number | null, remark?: string | null }> | null } };

export type PurchaseOrderUniqueIdQueryQueryVariables = Exact<{
  aggridInput?: InputMaybe<Scalars['AnyAggridInput']['input']>;
}>;


export type PurchaseOrderUniqueIdQueryQuery = { __typename?: 'Query', PurchaseOrderViewsAggrid: { __typename?: 'PurchaseOrderViewAggrid', results: Array<{ __typename?: 'PurchaseOrderView', id?: number | null, unique_id: string, item_list?: Array<any | null> | null }> } };

export type PurchaseOrderUpdateMutationVariables = Exact<{
  uniqueInput?: InputMaybe<PurchaseUniqueInput>;
  data?: InputMaybe<PurchaseOrderUpdateInput>;
}>;


export type PurchaseOrderUpdateMutation = { __typename?: 'Mutation', PurchaseOrderUpdate?: { __typename?: 'PurchaseOrder', id: number, unique_id: string, reference_no?: string | null, created_date: any, last_updated_date?: any | null, issue_date?: any | null, expected_date?: any | null, due_date?: any | null, credit_day?: number | null, within_date?: any | null, destination_warehouse_id?: number | null, related_user_list?: Array<any> | null, supplier_unique_id?: string | null, supplier_details?: any | null, price_vat_type?: PriceVatType | null, pre_vat_amount?: number | null, shipping_cost?: number | null, additional_discount?: number | null, additional_discount_type?: AdditionalDiscountType | null, post_discount_amount?: number | null, vat_exempted_amount?: number | null, vat_0_percent_amount?: number | null, vat_7_percent_amount?: number | null, vat_amount?: number | null, net_amount?: number | null, withholding_tax_amount?: number | null, total_amount?: number | null, remark?: string | null, main_status?: string | null, sub_status?: string | null, flag_status?: Array<string> | null, aggrid_status?: string | null, tag_id_list?: Array<number> | null, created_by?: { __typename?: 'CreatorObject', user_unique_id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, img_url?: Array<string> | null } | null, last_updated_by?: { __typename?: 'CreatorObject', user_id?: number | null, user_unique_id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, img_url?: Array<string> | null } | null, destination_warehouse?: { __typename?: 'Warehouse', id: number, unique_id: string, name: string } | null, tag_list?: Array<{ __typename?: 'Tag', id: number, name: string, document_type: TagDocumentType }> | null, item_list?: Array<{ __typename?: 'PurchaseItemList', id?: number | null, unique_id: string, reference_unique_id: string, reference_line_item?: any | null, reference_document_type?: ReferenceDocumentType | null, item_id: number, item_unique_id: string, item_name: string, item_desc?: string | null, item_img_url?: Array<string | null> | null, traceability?: Traceability | null, barcode: string, qty: number, po_qty?: number | null, wait_receive_qty?: number | null, qty_ordered?: number | null, qty_received?: number | null, qty_returned?: number | null, qty_issued?: number | null, uom_id?: number | null, uom_name?: string | null, uom?: any | null, uom_conversion_list?: Array<any | null> | null, price_per_unit?: number | null, discount?: number | null, vat_percentage?: string | null, pre_vat_amount?: number | null, pre_discount_amount?: number | null, vat_amount?: number | null, additional_discount?: number | null, post_discount_amount?: number | null, net_amount?: number | null, total_amount?: number | null, stock_qty?: number | null, withholding_tax_type?: string | null, withholding_tax_value?: number | null, remark?: string | null }> | null } | null };

export type PurchaseUniqueIdGenerateQueryVariables = Exact<{
  modelType: PurchaseModelType;
}>;


export type PurchaseUniqueIdGenerateQuery = { __typename?: 'Query', UniqueIdGenerate: string };

export type PurchaseReturnCreateMutationVariables = Exact<{
  data: PurchaseReturnCreateInput;
}>;


export type PurchaseReturnCreateMutation = { __typename?: 'Mutation', PurchaseReturnCreate: { __typename?: 'PurchaseReturn', id: number, unique_id: string, reference_no: string, created_date: any, issue_date?: any | null, delivery_date?: any | null, credit_day?: number | null, related_user_list?: Array<any> | null, reason_to_return?: string | null, supplier_unique_id?: string | null, supplier_details?: any | null, price_vat_type?: PriceVatType | null, pre_vat_amount?: number | null, additional_discount?: number | null, additional_discount_type?: AdditionalDiscountType | null, post_discount_amount?: number | null, vat_exempted_amount?: number | null, vat_0_percent_amount?: number | null, vat_7_percent_amount?: number | null, vat_amount?: number | null, net_amount?: number | null, withholding_tax_amount?: number | null, total_amount?: number | null, remark?: string | null, main_status?: string | null, flag_status?: Array<string> | null, aggrid_status?: string | null, reference_document_list?: Array<{ __typename?: 'ReferenceDocumentList', document_id?: number | null, document_unique_id?: string | null, document_type?: PurchaseDocumentType | null }> | null, created_by?: { __typename?: 'CreatorObject', user_unique_id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, img_url?: Array<string> | null } | null, last_updated_by?: { __typename?: 'CreatorObject', user_id?: number | null, user_unique_id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, img_url?: Array<string> | null } | null, item_list?: Array<{ __typename?: 'PurchaseItemList', id?: number | null, unique_id: string, reference_unique_id: string, reference_line_item?: any | null, reference_document_type?: ReferenceDocumentType | null, item_id: number, item_unique_id: string, item_name: string, item_desc?: string | null, item_img_url?: Array<string | null> | null, traceability?: Traceability | null, barcode: string, qty: number, po_qty?: number | null, rs_qty?: number | null, wait_receive_qty?: number | null, qty_ordered?: number | null, qty_received?: number | null, qty_returned?: number | null, qty_issued?: number | null, uom_id?: number | null, uom_name?: string | null, uom?: any | null, uom_conversion_list?: Array<any | null> | null, price_per_unit?: number | null, discount?: number | null, vat_percentage?: string | null, pre_vat_amount?: number | null, pre_discount_amount?: number | null, vat_amount?: number | null, additional_discount?: number | null, post_discount_amount?: number | null, net_amount?: number | null, total_amount?: number | null, stock_qty?: number | null, withholding_tax_type?: string | null, withholding_tax_value?: number | null, remark?: string | null }> | null } };

export type PurchaseReturnFindUniqueQueryVariables = Exact<{
  uniqueInput?: InputMaybe<PurchaseUniqueInput>;
}>;


export type PurchaseReturnFindUniqueQuery = { __typename?: 'Query', purchaseReturnFindUnique: { __typename?: 'PurchaseReturn', id: number, unique_id: string, reference_no: string, created_date: any, issue_date?: any | null, delivery_date?: any | null, credit_day?: number | null, related_user_list?: Array<any> | null, reason_to_return?: string | null, supplier_unique_id?: string | null, supplier_details?: any | null, price_vat_type?: PriceVatType | null, pre_vat_amount?: number | null, additional_discount?: number | null, additional_discount_type?: AdditionalDiscountType | null, post_discount_amount?: number | null, vat_exempted_amount?: number | null, vat_0_percent_amount?: number | null, vat_7_percent_amount?: number | null, vat_amount?: number | null, net_amount?: number | null, withholding_tax_amount?: number | null, total_amount?: number | null, remark?: string | null, main_status?: string | null, flag_status?: Array<string> | null, aggrid_status?: string | null, reference_document_list?: Array<{ __typename?: 'ReferenceDocumentList', document_id?: number | null, document_unique_id?: string | null, document_type?: PurchaseDocumentType | null }> | null, created_by?: { __typename?: 'CreatorObject', user_unique_id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, img_url?: Array<string> | null } | null, last_updated_by?: { __typename?: 'CreatorObject', user_id?: number | null, user_unique_id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, img_url?: Array<string> | null } | null, item_list?: Array<{ __typename?: 'PurchaseItemList', id?: number | null, unique_id: string, reference_unique_id: string, reference_line_item?: any | null, reference_document_type?: ReferenceDocumentType | null, item_id: number, item_unique_id: string, item_name: string, item_desc?: string | null, item_img_url?: Array<string | null> | null, traceability?: Traceability | null, barcode: string, qty: number, po_qty?: number | null, rs_qty?: number | null, wait_receive_qty?: number | null, qty_ordered?: number | null, qty_received?: number | null, qty_returned?: number | null, qty_issued?: number | null, uom_id?: number | null, uom_name?: string | null, uom?: any | null, uom_conversion_list?: Array<any | null> | null, price_per_unit?: number | null, discount?: number | null, vat_percentage?: string | null, pre_vat_amount?: number | null, pre_discount_amount?: number | null, vat_amount?: number | null, additional_discount?: number | null, post_discount_amount?: number | null, net_amount?: number | null, total_amount?: number | null, stock_qty?: number | null, withholding_tax_type?: string | null, withholding_tax_value?: number | null, remark?: string | null }> | null } };

export type PurchaseReturnUniqueIdQueryQueryVariables = Exact<{
  aggridInput?: InputMaybe<Scalars['AnyAggridInput']['input']>;
}>;


export type PurchaseReturnUniqueIdQueryQuery = { __typename?: 'Query', PurchaseReturnViewsAggrid: { __typename?: 'PurchaseReturnViewAggrid', results: Array<{ __typename?: 'PurchaseReturnView', id?: number | null, unique_id: string, item_list?: Array<any | null> | null }> } };

export type PurchaseReturnUpdateMutationVariables = Exact<{
  uniqueInput?: InputMaybe<PurchaseUniqueInput>;
  data?: InputMaybe<PurchaseReturnUpdateInput>;
}>;


export type PurchaseReturnUpdateMutation = { __typename?: 'Mutation', PurchaseReturnUpdate: { __typename?: 'PurchaseReturn', id: number, unique_id: string, reference_no: string, created_date: any, issue_date?: any | null, delivery_date?: any | null, credit_day?: number | null, related_user_list?: Array<any> | null, reason_to_return?: string | null, supplier_unique_id?: string | null, supplier_details?: any | null, price_vat_type?: PriceVatType | null, pre_vat_amount?: number | null, additional_discount?: number | null, additional_discount_type?: AdditionalDiscountType | null, post_discount_amount?: number | null, vat_exempted_amount?: number | null, vat_0_percent_amount?: number | null, vat_7_percent_amount?: number | null, vat_amount?: number | null, net_amount?: number | null, withholding_tax_amount?: number | null, total_amount?: number | null, remark?: string | null, main_status?: string | null, flag_status?: Array<string> | null, aggrid_status?: string | null, reference_document_list?: Array<{ __typename?: 'ReferenceDocumentList', document_id?: number | null, document_unique_id?: string | null, document_type?: PurchaseDocumentType | null }> | null, created_by?: { __typename?: 'CreatorObject', user_unique_id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, img_url?: Array<string> | null } | null, last_updated_by?: { __typename?: 'CreatorObject', user_id?: number | null, user_unique_id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, img_url?: Array<string> | null } | null, item_list?: Array<{ __typename?: 'PurchaseItemList', id?: number | null, unique_id: string, reference_unique_id: string, reference_line_item?: any | null, reference_document_type?: ReferenceDocumentType | null, item_id: number, item_unique_id: string, item_name: string, item_desc?: string | null, item_img_url?: Array<string | null> | null, traceability?: Traceability | null, barcode: string, qty: number, po_qty?: number | null, rs_qty?: number | null, wait_receive_qty?: number | null, qty_ordered?: number | null, qty_received?: number | null, qty_returned?: number | null, qty_issued?: number | null, uom_id?: number | null, uom_name?: string | null, uom?: any | null, uom_conversion_list?: Array<any | null> | null, price_per_unit?: number | null, discount?: number | null, vat_percentage?: string | null, pre_vat_amount?: number | null, pre_discount_amount?: number | null, vat_amount?: number | null, additional_discount?: number | null, post_discount_amount?: number | null, net_amount?: number | null, total_amount?: number | null, stock_qty?: number | null, withholding_tax_type?: string | null, withholding_tax_value?: number | null, remark?: string | null }> | null } };


export const PurchaseOrderCreateDocument = `
    mutation PurchaseOrderCreate($data: PurchaseOrderInput) {
  PurchaseOrderCreate(data: $data) {
    id
    unique_id
    reference_no
    created_date
    created_by {
      user_unique_id
      first_name
      last_name
      email
      img_url
    }
    last_updated_date
    last_updated_by {
      user_id
      user_unique_id
      first_name
      last_name
      email
      img_url
    }
    issue_date
    expected_date
    due_date
    credit_day
    within_date
    destination_warehouse_id
    destination_warehouse {
      id
      unique_id
      name
    }
    related_user_list
    supplier_unique_id
    supplier_details
    price_vat_type
    pre_vat_amount
    shipping_cost
    additional_discount
    additional_discount_type
    post_discount_amount
    vat_exempted_amount
    vat_0_percent_amount
    vat_7_percent_amount
    vat_amount
    net_amount
    withholding_tax_amount
    total_amount
    remark
    main_status
    sub_status
    flag_status
    aggrid_status
    tag_id_list
    tag_list {
      id
      name
      document_type
    }
    item_list {
      id
      unique_id
      reference_unique_id
      reference_line_item
      reference_document_type
      item_id
      item_unique_id
      item_name
      item_desc
      item_img_url
      traceability
      barcode
      qty
      po_qty
      wait_receive_qty
      qty_ordered
      qty_received
      qty_returned
      qty_issued
      uom_id
      uom_name
      uom
      uom_conversion_list
      price_per_unit
      discount
      vat_percentage
      pre_vat_amount
      pre_discount_amount
      vat_amount
      additional_discount
      post_discount_amount
      net_amount
      total_amount
      stock_qty
      withholding_tax_type
      withholding_tax_value
      remark
    }
  }
}
    `;
export const usePurchaseOrderCreateMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<PurchaseOrderCreateMutation, TError, PurchaseOrderCreateMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<PurchaseOrderCreateMutation, TError, PurchaseOrderCreateMutationVariables, TContext>(
      ['PurchaseOrderCreate'],
      (variables?: PurchaseOrderCreateMutationVariables) => fetcher<PurchaseOrderCreateMutation, PurchaseOrderCreateMutationVariables>(client, PurchaseOrderCreateDocument, variables, headers)(),
      options
    );
export const PurchaseOrderFindUniqueDocument = `
    query PurchaseOrderFindUnique($uniqueInput: PurchaseUniqueInput) {
  PurchaseOrderFindUnique(uniqueInput: $uniqueInput) {
    id
    unique_id
    reference_no
    created_date
    created_by {
      user_unique_id
      first_name
      last_name
      email
      img_url
    }
    last_updated_date
    last_updated_by {
      user_id
      user_unique_id
      first_name
      last_name
      email
      img_url
    }
    issue_date
    within_date
    expected_date
    due_date
    credit_day
    within_date
    destination_warehouse_id
    destination_warehouse {
      id
      unique_id
      name
    }
    related_user_list
    supplier_unique_id
    supplier_details
    price_vat_type
    pre_vat_amount
    shipping_cost
    additional_discount
    additional_discount_type
    post_discount_amount
    vat_exempted_amount
    vat_0_percent_amount
    vat_7_percent_amount
    vat_amount
    net_amount
    withholding_tax_amount
    total_amount
    remark
    main_status
    sub_status
    flag_status
    aggrid_status
    tag_id_list
    tag_list {
      id
      name
      document_type
    }
    item_list {
      id
      unique_id
      reference_unique_id
      reference_line_item
      reference_document_type
      item_id
      item_unique_id
      item_name
      item_desc
      item_img_url
      traceability
      barcode
      qty
      po_qty
      wait_receive_qty
      qty_ordered
      qty_received
      qty_returned
      qty_issued
      uom_id
      uom_name
      uom
      uom_conversion_list
      price_per_unit
      discount
      vat_percentage
      pre_vat_amount
      pre_discount_amount
      vat_amount
      additional_discount
      post_discount_amount
      net_amount
      total_amount
      stock_qty
      withholding_tax_type
      withholding_tax_value
      remark
    }
  }
}
    `;
export const usePurchaseOrderFindUniqueQuery = <
      TData = PurchaseOrderFindUniqueQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: PurchaseOrderFindUniqueQueryVariables,
      options?: UseQueryOptions<PurchaseOrderFindUniqueQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<PurchaseOrderFindUniqueQuery, TError, TData>(
      variables === undefined ? ['PurchaseOrderFindUnique'] : ['PurchaseOrderFindUnique', variables],
      fetcher<PurchaseOrderFindUniqueQuery, PurchaseOrderFindUniqueQueryVariables>(client, PurchaseOrderFindUniqueDocument, variables, headers),
      options
    );
export const PurchaseOrderUniqueIdQueryDocument = `
    query PurchaseOrderUniqueIdQuery($aggridInput: AnyAggridInput) {
  PurchaseOrderViewsAggrid(aggridInput: $aggridInput) {
    results {
      id
      unique_id
      item_list
    }
  }
}
    `;
export const usePurchaseOrderUniqueIdQueryQuery = <
      TData = PurchaseOrderUniqueIdQueryQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: PurchaseOrderUniqueIdQueryQueryVariables,
      options?: UseQueryOptions<PurchaseOrderUniqueIdQueryQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<PurchaseOrderUniqueIdQueryQuery, TError, TData>(
      variables === undefined ? ['PurchaseOrderUniqueIdQuery'] : ['PurchaseOrderUniqueIdQuery', variables],
      fetcher<PurchaseOrderUniqueIdQueryQuery, PurchaseOrderUniqueIdQueryQueryVariables>(client, PurchaseOrderUniqueIdQueryDocument, variables, headers),
      options
    );
export const PurchaseOrderUpdateDocument = `
    mutation PurchaseOrderUpdate($uniqueInput: PurchaseUniqueInput, $data: PurchaseOrderUpdateInput) {
  PurchaseOrderUpdate(uniqueInput: $uniqueInput, data: $data) {
    id
    unique_id
    reference_no
    created_date
    created_by {
      user_unique_id
      first_name
      last_name
      email
      img_url
    }
    last_updated_date
    last_updated_by {
      user_id
      user_unique_id
      first_name
      last_name
      email
      img_url
    }
    issue_date
    expected_date
    due_date
    credit_day
    within_date
    destination_warehouse_id
    destination_warehouse {
      id
      unique_id
      name
    }
    related_user_list
    supplier_unique_id
    supplier_details
    price_vat_type
    pre_vat_amount
    shipping_cost
    additional_discount
    additional_discount_type
    post_discount_amount
    vat_exempted_amount
    vat_0_percent_amount
    vat_7_percent_amount
    vat_amount
    net_amount
    withholding_tax_amount
    total_amount
    remark
    main_status
    sub_status
    flag_status
    aggrid_status
    tag_id_list
    tag_list {
      id
      name
      document_type
    }
    item_list {
      id
      unique_id
      reference_unique_id
      reference_line_item
      reference_document_type
      item_id
      item_unique_id
      item_name
      item_desc
      item_img_url
      traceability
      barcode
      qty
      po_qty
      wait_receive_qty
      qty_ordered
      qty_received
      qty_returned
      qty_issued
      uom_id
      uom_name
      uom
      uom_conversion_list
      price_per_unit
      discount
      vat_percentage
      pre_vat_amount
      pre_discount_amount
      vat_amount
      additional_discount
      post_discount_amount
      net_amount
      total_amount
      stock_qty
      withholding_tax_type
      withholding_tax_value
      remark
    }
  }
}
    `;
export const usePurchaseOrderUpdateMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<PurchaseOrderUpdateMutation, TError, PurchaseOrderUpdateMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<PurchaseOrderUpdateMutation, TError, PurchaseOrderUpdateMutationVariables, TContext>(
      ['PurchaseOrderUpdate'],
      (variables?: PurchaseOrderUpdateMutationVariables) => fetcher<PurchaseOrderUpdateMutation, PurchaseOrderUpdateMutationVariables>(client, PurchaseOrderUpdateDocument, variables, headers)(),
      options
    );
export const PurchaseUniqueIdGenerateDocument = `
    query PurchaseUniqueIdGenerate($modelType: PurchaseModelType!) {
  UniqueIdGenerate(modelType: $modelType)
}
    `;
export const usePurchaseUniqueIdGenerateQuery = <
      TData = PurchaseUniqueIdGenerateQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: PurchaseUniqueIdGenerateQueryVariables,
      options?: UseQueryOptions<PurchaseUniqueIdGenerateQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<PurchaseUniqueIdGenerateQuery, TError, TData>(
      ['PurchaseUniqueIdGenerate', variables],
      fetcher<PurchaseUniqueIdGenerateQuery, PurchaseUniqueIdGenerateQueryVariables>(client, PurchaseUniqueIdGenerateDocument, variables, headers),
      options
    );
export const PurchaseReturnCreateDocument = `
    mutation PurchaseReturnCreate($data: PurchaseReturnCreateInput!) {
  PurchaseReturnCreate(data: $data) {
    id
    unique_id
    reference_document_list {
      document_id
      document_unique_id
      document_type
    }
    reference_no
    created_date
    created_by {
      user_unique_id
      first_name
      last_name
      email
      img_url
    }
    last_updated_by {
      user_id
      user_unique_id
      first_name
      last_name
      email
      img_url
    }
    issue_date
    delivery_date
    credit_day
    related_user_list
    reason_to_return
    supplier_unique_id
    supplier_details
    price_vat_type
    pre_vat_amount
    additional_discount
    additional_discount_type
    post_discount_amount
    vat_exempted_amount
    vat_0_percent_amount
    vat_7_percent_amount
    vat_amount
    net_amount
    withholding_tax_amount
    total_amount
    remark
    main_status
    flag_status
    aggrid_status
    item_list {
      id
      unique_id
      reference_unique_id
      reference_line_item
      reference_document_type
      item_id
      item_unique_id
      item_name
      item_desc
      item_img_url
      traceability
      barcode
      qty
      po_qty
      rs_qty
      wait_receive_qty
      qty_ordered
      qty_received
      qty_returned
      qty_issued
      uom_id
      uom_name
      uom
      uom_conversion_list
      price_per_unit
      discount
      vat_percentage
      pre_vat_amount
      pre_discount_amount
      vat_amount
      additional_discount
      post_discount_amount
      net_amount
      total_amount
      stock_qty
      withholding_tax_type
      withholding_tax_value
      remark
    }
  }
}
    `;
export const usePurchaseReturnCreateMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<PurchaseReturnCreateMutation, TError, PurchaseReturnCreateMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<PurchaseReturnCreateMutation, TError, PurchaseReturnCreateMutationVariables, TContext>(
      ['PurchaseReturnCreate'],
      (variables?: PurchaseReturnCreateMutationVariables) => fetcher<PurchaseReturnCreateMutation, PurchaseReturnCreateMutationVariables>(client, PurchaseReturnCreateDocument, variables, headers)(),
      options
    );
export const PurchaseReturnFindUniqueDocument = `
    query PurchaseReturnFindUnique($uniqueInput: PurchaseUniqueInput) {
  purchaseReturnFindUnique(uniqueInput: $uniqueInput) {
    id
    unique_id
    reference_document_list {
      document_id
      document_unique_id
      document_type
    }
    reference_no
    created_date
    created_by {
      user_unique_id
      first_name
      last_name
      email
      img_url
    }
    last_updated_by {
      user_id
      user_unique_id
      first_name
      last_name
      email
      img_url
    }
    issue_date
    delivery_date
    credit_day
    related_user_list
    reason_to_return
    supplier_unique_id
    supplier_details
    price_vat_type
    pre_vat_amount
    additional_discount
    additional_discount_type
    post_discount_amount
    vat_exempted_amount
    vat_0_percent_amount
    vat_7_percent_amount
    vat_amount
    net_amount
    withholding_tax_amount
    total_amount
    remark
    main_status
    flag_status
    aggrid_status
    item_list {
      id
      unique_id
      reference_unique_id
      reference_line_item
      reference_document_type
      item_id
      item_unique_id
      item_name
      item_desc
      item_img_url
      traceability
      barcode
      qty
      po_qty
      rs_qty
      wait_receive_qty
      qty_ordered
      qty_received
      qty_returned
      qty_issued
      uom_id
      uom_name
      uom
      uom_conversion_list
      price_per_unit
      discount
      vat_percentage
      pre_vat_amount
      pre_discount_amount
      vat_amount
      additional_discount
      post_discount_amount
      net_amount
      total_amount
      stock_qty
      withholding_tax_type
      withholding_tax_value
      remark
    }
  }
}
    `;
export const usePurchaseReturnFindUniqueQuery = <
      TData = PurchaseReturnFindUniqueQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: PurchaseReturnFindUniqueQueryVariables,
      options?: UseQueryOptions<PurchaseReturnFindUniqueQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<PurchaseReturnFindUniqueQuery, TError, TData>(
      variables === undefined ? ['PurchaseReturnFindUnique'] : ['PurchaseReturnFindUnique', variables],
      fetcher<PurchaseReturnFindUniqueQuery, PurchaseReturnFindUniqueQueryVariables>(client, PurchaseReturnFindUniqueDocument, variables, headers),
      options
    );
export const PurchaseReturnUniqueIdQueryDocument = `
    query PurchaseReturnUniqueIdQuery($aggridInput: AnyAggridInput) {
  PurchaseReturnViewsAggrid(aggridInput: $aggridInput) {
    results {
      id
      unique_id
      item_list
    }
  }
}
    `;
export const usePurchaseReturnUniqueIdQueryQuery = <
      TData = PurchaseReturnUniqueIdQueryQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: PurchaseReturnUniqueIdQueryQueryVariables,
      options?: UseQueryOptions<PurchaseReturnUniqueIdQueryQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<PurchaseReturnUniqueIdQueryQuery, TError, TData>(
      variables === undefined ? ['PurchaseReturnUniqueIdQuery'] : ['PurchaseReturnUniqueIdQuery', variables],
      fetcher<PurchaseReturnUniqueIdQueryQuery, PurchaseReturnUniqueIdQueryQueryVariables>(client, PurchaseReturnUniqueIdQueryDocument, variables, headers),
      options
    );
export const PurchaseReturnUpdateDocument = `
    mutation PurchaseReturnUpdate($uniqueInput: PurchaseUniqueInput, $data: PurchaseReturnUpdateInput) {
  PurchaseReturnUpdate(uniqueInput: $uniqueInput, data: $data) {
    id
    unique_id
    reference_document_list {
      document_id
      document_unique_id
      document_type
    }
    reference_no
    created_date
    created_by {
      user_unique_id
      first_name
      last_name
      email
      img_url
    }
    last_updated_by {
      user_id
      user_unique_id
      first_name
      last_name
      email
      img_url
    }
    issue_date
    delivery_date
    credit_day
    related_user_list
    reason_to_return
    supplier_unique_id
    supplier_details
    price_vat_type
    pre_vat_amount
    additional_discount
    additional_discount_type
    post_discount_amount
    vat_exempted_amount
    vat_0_percent_amount
    vat_7_percent_amount
    vat_amount
    net_amount
    withholding_tax_amount
    total_amount
    remark
    main_status
    flag_status
    aggrid_status
    item_list {
      id
      unique_id
      reference_unique_id
      reference_line_item
      reference_document_type
      item_id
      item_unique_id
      item_name
      item_desc
      item_img_url
      traceability
      barcode
      qty
      po_qty
      rs_qty
      wait_receive_qty
      qty_ordered
      qty_received
      qty_returned
      qty_issued
      uom_id
      uom_name
      uom
      uom_conversion_list
      price_per_unit
      discount
      vat_percentage
      pre_vat_amount
      pre_discount_amount
      vat_amount
      additional_discount
      post_discount_amount
      net_amount
      total_amount
      stock_qty
      withholding_tax_type
      withholding_tax_value
      remark
    }
  }
}
    `;
export const usePurchaseReturnUpdateMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<PurchaseReturnUpdateMutation, TError, PurchaseReturnUpdateMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<PurchaseReturnUpdateMutation, TError, PurchaseReturnUpdateMutationVariables, TContext>(
      ['PurchaseReturnUpdate'],
      (variables?: PurchaseReturnUpdateMutationVariables) => fetcher<PurchaseReturnUpdateMutation, PurchaseReturnUpdateMutationVariables>(client, PurchaseReturnUpdateDocument, variables, headers)(),
      options
    );